import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Response } from '@angular/http';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

export abstract class BaseFormComponent {
  public form: FormGroup;

  formErrors: any;
  protected validationMessages: any;

  constructor(formErrors: any, validationMessages: any, fb: FormBuilder) {
    this.formErrors = formErrors;
    this.validationMessages = validationMessages;
  }

  abstract initializeForm(): FormGroup;

  abstract sendForm(): any;

  abstract handleErrors(errors: Response);

  buildForm() {
    this.form = this.initializeForm();

    this.form.valueChanges
      .pipe(debounceTime(1000))
      .subscribe((data) => this.onValueChanged(data));

    this.onValueChanged();
  }

  get formValue() {
    return this.form.value;
  }

  onValueChanged(data?: any) {
    if (!this.form) throw new Error('No form defined.');
    const form = this.form;

    for (const field in this.formErrors) {
      this.formErrors[field] = '';
      if (this.form.invalid) {
        const control = form.get(field);

        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];

          if (this.formErrors[field] === '') {
            for (const key in control.errors) {
              if (key === 'maxlength') {
                this.maxLengthError(key, field, control);
                break;
              }

              this.formErrors[field] = messages[key] + ' ';
              break;
            }
          }
        }
      }

      this.handleErrors(this.formErrors);
    }
  }

  public onSubmit(values: Object): Observable<any> {
    for (let c in this.form.controls) {
      this.form.controls[c].markAsDirty();
    }

    this.onValueChanged();

    if (this.form.invalid) return;
    return this.sendForm();
  }

  addNewField(fieldName: string, message: string, required: boolean = true) {
    if (required) {
      let genericField: FormControl = new FormControl(
        '',
        Validators.compose([Validators.required])
      );
      let msg = { required: message };
      this.form.addControl(fieldName, genericField);
      this.validationMessages[fieldName] = msg;
      this.formErrors[fieldName] = null;
    } else {
      let genericField: FormControl = new FormControl('');
      this.form.addControl(fieldName, genericField);
      this.formErrors[fieldName] = null;
    }
  }

  removeField(fieldName: string) {
    this.form.removeControl(fieldName);
  }

  public formFill(values: object) {
    Object.keys(this.form.controls).forEach((key) => {
      this.form.controls[key].setValue(values[key]);
    });

    this.onValueChanged();
  }

  maxLengthError(key, field, control) {
    let message = this.validationMessages[field];
    message =
      message[key].replace('{requiredLength}', control.errors[key].requiredLength) + ' ';

    this.formErrors[field] = message;
  }
}
